import React from "react";
import { CURRENCIES } from "../../config/currencyLocalization";
import { formatLocalizedAmount } from "../../services/currencyLocalizationService";

const defaultStyle = { color: "#182230", fontSize: "20px" };

const resolveCurrencyConfig = (code) => {
  const normalized = String(code || "")
    .trim()
    .toUpperCase();
  return CURRENCIES[normalized] || null;
};

const LocalizedPrice = ({
  amount,
  fromCurrency,
  amountGbp,
  localization,
  style = defaultStyle,
}) => {
  const planAmount = amount ?? amountGbp;
  const planCurrency = fromCurrency
    ? String(fromCurrency).trim().toUpperCase()
    : null;

  let displayValue = planAmount;
  if (localization?.format && planCurrency) {
    displayValue = localization.format(planAmount, planCurrency);
  } else if (planCurrency) {
    const currencyConfig = resolveCurrencyConfig(planCurrency);
    if (currencyConfig) {
      displayValue = formatLocalizedAmount(planAmount, currencyConfig);
    }
  }

  return <strong style={style}>{displayValue}</strong>;
};

export default LocalizedPrice;
